{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ArrowSwIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ArrowSwIcon = React.forwardRef<SVGSVGElement, ArrowSwIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 108 109"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<path d="M61.9627 50.6754C74.5845 37.8475 87.2006 25.0133 99.8111 12.1727C102.319 9.60773 104.66 6.86884 106.938 4.0945C107.31 3.63169 107.535 3.06719 107.582 2.47481C107.628 1.88243 107.495 1.28975 107.2 0.774116C106.758 -0.0791227 105.115 -0.283244 104.115 0.445948C103.148 1.1502 102.114 1.77761 101.223 2.56719C95.5369 7.60524 89.7152 12.5055 84.2519 17.7758C73.0285 28.6054 61.9482 39.5833 50.9099 50.5993C40.4347 61.0508 30.104 71.6448 19.663 82.1325C17.9867 83.816 16.0937 85.2861 14.2671 86.8134C14.1283 86.8972 13.9706 86.9448 13.8085 86.9518C13.6465 86.9588 13.4854 86.925 13.3398 86.8535C13.0511 86.6244 12.69 86.1151 12.7694 85.846C14.237 80.8821 15.574 75.8697 17.3205 71.0016C21.3832 59.6811 24.1463 48.016 26.8944 36.341C27.3453 34.4226 27.8423 32.4358 26.8643 30.4996C26.6858 30.1478 26.3674 29.5585 26.1686 29.5808C25.4041 29.6075 24.6583 29.8231 23.9975 30.2082C23.3747 30.6995 22.9006 31.3541 22.6282 32.0991C21.6437 34.7166 20.7059 37.3564 19.8678 40.0251C13.8807 59.0943 7.9532 78.1819 1.93918 97.2426C-0.329128 104.433 -0.19188 109.064 10.8924 108.794C14.0861 108.717 17.2976 108.62 20.4637 108.228C35.1469 106.415 49.8213 104.534 64.4869 102.584C66.4486 102.26 68.3822 101.784 70.2699 101.16C71.5334 100.786 72.0892 99.7019 72.2638 98.4614C72.4554 97.0962 71.232 94.906 70.2127 94.4243C67.9503 93.3544 65.5396 93.3197 63.1571 93.489C53.9835 94.1401 44.8158 94.8739 35.6488 95.6136C29.6761 96.0953 23.7133 96.6513 17.7413 97.1232C17.4466 97.1462 17.0159 96.7294 16.8289 96.415C16.7616 96.2629 16.7325 96.0966 16.744 95.9307C16.7554 95.7647 16.8071 95.6041 16.8946 95.4626C18.4698 93.6689 20.0135 91.8409 21.7075 90.1646C35.0692 76.9434 48.4479 63.7399 61.8438 50.554L61.9627 50.6754Z" fill={color}/>

      </svg>
    )
  }
)

ArrowSwIcon.displayName = 'ArrowSwIcon'
